import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// `cn` — shadcn convention. Merges conditional class lists (clsx) and resolves
// Tailwind utility conflicts (tailwind-merge v3 supports v4 utility names).
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
